import type { FC } from 'react';
import { settingsUrlBase, settingsPagePaths } from 'pages/Settings/paths';
import type { AccessStruct } from '@kizen/permissions/types';
import { ServiceAccounts } from './ServiceAccounts';
import { IntegrationSecretsPage } from './IntegrationSecrets';
import { TeamApiAccess } from './TeamApiAccess';

export type ManageConnectionsAccess = {
  enabled: boolean;
  manageStandardApiKeys: AccessStruct;
  manageOauthAuthorizations: AccessStruct;
  manageIntegrationSecrets: AccessStruct;
  manageServiceAccounts: AccessStruct;
};

export type AccessPathKey = keyof Omit<ManageConnectionsAccess, 'enabled'>;
type AccessLevel = 'view' | 'edit' | 'remove';

type SubRoute = {
  path: string;
  label: (t: (x: string) => string) => string;
  component: FC<{ access: ManageConnectionsAccess }>;
  exact: boolean;
  accessPaths: Partial<Record<AccessPathKey, AccessLevel>>;
};

const MANAGE_CONNECTIONS_ROUTE = `${settingsUrlBase}/${settingsPagePaths.manageConnections}`;
export const SERVICE_ACCOUNTS_ROUTE = `${MANAGE_CONNECTIONS_ROUTE}/service-accounts`;
export const INTEGRATION_SECRETS_ROUTE = `${MANAGE_CONNECTIONS_ROUTE}/integration-secrets`;
export const TEAM_API_ACCESS_ROUTE = `${MANAGE_CONNECTIONS_ROUTE}/team-api-access`;

export const subroutes: Record<string, SubRoute> = {
  [SERVICE_ACCOUNTS_ROUTE]: {
    path: SERVICE_ACCOUNTS_ROUTE,
    label: (t) => t('Service Accounts'),
    component: ServiceAccounts as FC<{ access: ManageConnectionsAccess }>,
    exact: true,
    accessPaths: { manageServiceAccounts: 'view' },
  },
  [INTEGRATION_SECRETS_ROUTE]: {
    path: INTEGRATION_SECRETS_ROUTE,
    label: (t) => t('Integration Secrets'),
    component: IntegrationSecretsPage as FC<{
      access: ManageConnectionsAccess;
    }>,
    exact: true,
    accessPaths: { manageIntegrationSecrets: 'view' },
  },
  [TEAM_API_ACCESS_ROUTE]: {
    path: TEAM_API_ACCESS_ROUTE,
    label: (t) => t('Team API Access'),
    component: TeamApiAccess as FC<{ access: ManageConnectionsAccess }>,
    exact: true,
    accessPaths: {
      manageStandardApiKeys: 'view',
      manageOauthAuthorizations: 'view',
    },
  },
};
